import React, { useEffect, useState } from "react";
import Filter from "./Components/Filter";
import Table from "./Components/Table";
import ActivityDetail from "./Components/ActivityDetail";
import { useDispatch, useSelector } from "react-redux";
import { getKidSubmission, kidsPendingSubmission, removeSubmission, reviewSubmission, submitActivity } from "../../../../../../../redux/actions/event";
import { Confirm } from "notiflix";

const Submission = ({ data }) => {

  const dispatch = useDispatch();

  const pendingSubmissionKids = useSelector(state => state.event.pendingSubmissionKids);
  const submissionList = useSelector(state => state.event.submissionList);

  const [kid, setKid] = useState({ kidId: null, name: null });
  const [activePage, setActivePage] = useState(1);


  useEffect(() => {
    dispatch(kidsPendingSubmission({ activityId: data?.id, competitionId: data?.event_id, pageNo: (activePage - 1), pageSize: 10 }))
  }, [])

  useEffect(() => {
    if (kid?.kidId) {
      dispatch(getKidSubmission({ activityId: data?.id, competitionId: data?.event_id, isActive: true, kidId: kid?.kidId }));
    }
  }, [kid])

  const handleActivitySubmit = (postData, cb) => {
    dispatch(submitActivity(postData, { activityId: data?.id, competitionId: data?.event_id, kidId: kid?.kidId }, () => {
      setActivePage(1);
      dispatch(getKidSubmission({ activityId: data?.id, competitionId: data?.event_id, isActive: true, kidId: kid?.kidId }));
      dispatch(kidsPendingSubmission({ activityId: data?.id, competitionId: data?.event_id, pageNo: 0, pageSize: 10 }))
      cb();
    }))
  }

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(kidsPendingSubmission({ activityId: data?.id, competitionId: data?.event_id, pageNo: page, pageSize: 10 }))
  }

  const deleteSubmission = postData => {
    Confirm.show(
      'Confirm Delete',
      `Are you sure you want to detele the submission? Submissions can be deleted within 30 mins only`,
      'Yes',
      'No',
      function okCb() {
        const payload = {
          activityId: postData.activityId,
          activityName: postData.activityName,
          competitionId: postData.competitionId,
          competitionName: postData.competitionName,
          consent: true,
          email: postData.email,
          language: "English",
          isActive: false,
          submissionId: postData.id,
          kidName: postData.kidName,
          kidUniqueId: postData.kidUniqueId,
          registrationNumber: postData.registrationNumber,
          submissionUrls: postData.submissionUrls
        }
        dispatch(removeSubmission(payload, () => {
          setActivePage(1);
          dispatch(getKidSubmission({ activityId: data?.id, competitionId: data?.event_id, isActive: true, kidId: kid?.kidId }));
          dispatch(kidsPendingSubmission({ activityId: data?.id, competitionId: data?.event_id, pageNo: 0, pageSize: 10 }))
        }));
      },
      function cancelCb() { },
      {
        className: 'notiflix-confirm',
        width: '320px',
        borderRadius: '8px',
      },
    );
  }

  const review_submission = postData => {
    Confirm.show(
      'Confirm Review',
      `Are you sure you want to request a Review?`,
      'Yes',
      'No',
      function okCb() {
        const payload = {
          activityId: postData.activityId,
          activityName: postData.activityName,
          competitionId: postData.competitionId,
          competitionName: postData.competitionName,
          consent: true,
          email: postData.email,
          language: "English",
          isActive: true,
          submissionId: postData.id,
          kidName: postData.kidName,
          kidUniqueId: postData.kidUniqueId,
          registrationNumber: postData.registrationNumber,
          submissionUrls: postData.submissionUrls
        }
        dispatch(reviewSubmission(payload, () => {
          setActivePage(1);
          dispatch(getKidSubmission({ activityId: data?.id, competitionId: data?.event_id, isActive: true, kidId: kid?.kidId }));
          dispatch(kidsPendingSubmission({ activityId: data?.id, competitionId: data?.event_id, pageNo: 0, pageSize: 10 }))
        }));
      },
      function cancelCb() { },
      {
        className: 'notiflix-confirm',
        width: '320px',
        borderRadius: '8px',
      },
    );
  }

  return (
    <React.Fragment>
      <Filter activityId={data?.id} competitionId={data?.event_id} setKid={setKid} kid={kid} />
      <div className="border-top my-4"></div>
      {kid?.kidId && <>
        <ActivityDetail data={submissionList} handleActivitySubmit={handleActivitySubmit} deleteSubmission={deleteSubmission} review_submission={review_submission} />
        <div className="border-top my-5"></div>
      </>}
      <Table data={pendingSubmissionKids} handlePageChange={handlePageChange} activePage={activePage} />
    </React.Fragment>
  );
};

export default Submission;
